import { baseApi } from "../baseApi";

export const AddressApi = baseApi.injectEndpoints({

    endpoints: (builder) => ({
        getdocname: builder.query({
            query: (params) => ({
                url: `/api/resource/DocType`,
                method: "GET",
                params: {
                    limit_start: 0,
                    limit_page_length: 2500,
                    order_by: "`tabDocType`.`modified` desc",
                },
            })
        }),
        getDoctypeitem: builder.query({
            query: (name) => ({
                url: `/api/resource/${name}`,
            })
        }),
        createAddress: builder.mutation({
            query: (addressData) => ({
                url: `/api/resource/Address`,
                method: 'POST',
                body: addressData,
            }),
            invalidatesTags: ['customer']
        }),
        updateAddress: builder.mutation({
            query: ({ addressName, addressData }) => ({
                url: `/api/resource/Address/${encodeURIComponent(addressName)}`,
                method: 'PUT',
                body: addressData,
            }),
            invalidatesTags: ['customer'], // optional: depends on your tag logic
        }),
        getAddresses: builder.query({
            query: ({ start = 0, limit = 12, filters = [] }) => {
                const fields = [
                    "`tabAddress`.`name`",
                    "`tabAddress`.`owner`",
                    "`tabAddress`.`creation`",
                    "`tabAddress`.`modified`",
                    "`tabAddress`.`modified_by`",
                    "`tabAddress`.`_user_tags`",
                    "`tabAddress`.`_comments`",
                    "`tabAddress`.`_assign`",
                    "`tabAddress`.`_liked_by`",
                    "`tabAddress`.`docstatus`",
                    "`tabAddress`.`idx`",
                    "`tabAddress`.`address_type`",
                    "`tabAddress`.`city`",
                    "`tabAddress`.`disabled`",
                ];

                return {
                    url: `/api/resource/Address`,
                    params: {
                        fields: JSON.stringify(fields),
                        limit_start: start,
                        limit_page_length: limit,
                        order_by: "`tabAddress`.`modified` desc",
                        ...(filters.length > 0 && { filters: JSON.stringify(filters) })
                    },
                };
            },
            providesTags: ['Address'],
        }),

        getAddressGroupCount: builder.query({
            query: () => ({
                url: '/api/method/frappe.client.get_count',
                params: {
                    doctype: 'Address',
                },
            }),
        }),
        getAddressByName: builder.query({
            query: (name) => ({
                url: `/api/resource/Address/${encodeURIComponent(name)}`,
            }),
            providesTags: ['Address'],
        }),
        addressListss: builder.query({
            query: () => ({
                url: `/api/resource/Address`,
                method: "GET",
                params: {
                    fields: JSON.stringify(["name"]),
                    limit_page_length: 0,  
                },
            }),
        }),

    }),
});

export const {useAddressListssQuery, useUpdateAddressMutation, useGetAddressGroupCountQuery, useGetAddressByNameQuery, useGetAddressesQuery, useCreateAddressMutation, useLazyGetDoctypeitemQuery, useGetDoctypeitemQuery, useGetDoctypeDetailsQuery, useGetdocnameQuery } = AddressApi;
